/** Modern refresh of IDMS charge-off accent (#cf5c60). */
export const ACCOUNT_STATUS_CHARGE_OFF_COLOR = "#E2575C";
/** iDMS list Acct Status color when BANKRUPTCY is present. */
export const ACCOUNT_STATUS_BANKRUPTCY_COLOR = "#E67E22";

const normalizeAccountStatus = (actStatus) =>
  String(actStatus || "").trim().toLowerCase();

const capitalizeStatusWords = (str) =>
  String(str || "")
    .toLowerCase()
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const hasBankruptcyFlag = (flags = []) =>
  (flags || []).some((f) =>
    String(typeof f === "string" ? f : f?.name || "")
      .toUpperCase()
      .includes("BANKRUPT")
  );

/** iDMS BANKRUPTCY status overlay — calculus.is_bankruptcy, with flag fallback for old imports. */
export const isBankruptcyAccount = (row = {}) =>
  Boolean(row?.is_bankruptcy ?? row?.isBankruptcy) || hasBankruptcyFlag(row?.flags);

/**
 * iDMS-style Acct Status label (detail cards).
 * Bankruptcy overlays act_status: "Active - Bankruptcy" / "Out For Repo - Bankruptcy".
 * LOCK appends " LOCKED" like iDMS SecondaryStatus L.
 */
export const formatAccountStatusLabel = (
  actStatus,
  { isLock = false, flags = [], isBankruptcy = false } = {}
) => {
  if (!actStatus) return "-";
  const status = normalizeAccountStatus(actStatus);
  let label = capitalizeStatusWords(String(actStatus).replace(/_/g, " "));

  if (isBankruptcy || hasBankruptcyFlag(flags)) {
    if (status === "active") label = "Active - Bankruptcy";
    else if (status === "out_for_repo") label = "Out For Repo - Bankruptcy";
    else if (status === "repossessed") label = "Repossessed - Bankruptcy";
    else if (status === "charge_off") label = "Charge Off - Bankruptcy";
    else label = `${label} - Bankruptcy`;
  }

  if (isLock) {
    label = `${label} LOCKED`.replace(/\s+/g, " ").trim();
  }
  return label;
};

/**
 * iDMS accounts list style: "Active [Bankruptcy]" (any act_status + bankruptcy).
 */
export const formatAccountListStatusLabel = (
  actStatus,
  { flags = [], isBankruptcy = false } = {}
) => {
  if (!actStatus) return "-";
  const base = capitalizeStatusWords(String(actStatus).replace(/_/g, " "));
  return isBankruptcy || hasBankruptcyFlag(flags) ? `${base} [Bankruptcy]` : base;
};

export const getAccountStatusColor = (actStatus, { flags, isBankruptcy } = {}) => {
  if (isBankruptcy || hasBankruptcyFlag(flags)) return ACCOUNT_STATUS_BANKRUPTCY_COLOR;

  const status = normalizeAccountStatus(actStatus);

  if (status === "repossessed") return "#EB0C0C";
  if (status === "out_for_repo") return "#D47300";
  if (status === "closed") return "#00008B";
  if (status === "charge_off") return ACCOUNT_STATUS_CHARGE_OFF_COLOR;

  return "#28a745";
};
